import { QuoteEntity, QuotePage as QuotePageEntity, QuotePageQuery, QuoteQuery } from '@/graphql/generated/graphql';
import { initializeApollo } from '../lib/apollo-client';
import requestHandler from '../requestHandler';
import { QUERY_CURRENT_QUOTE, QUERY_QUOTE_PAGE } from '@/graphql/queries/daily/quote';
export const getPage = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<QuotePageQuery>({
      query: QUERY_QUOTE_PAGE,
    }),
  );

  return { data: data?.quotePage?.data?.attributes as QuotePageEntity, error };
};

export const getDailyQuote = async (): Promise<QuoteEntity | null> => {
  const now = new Date();
  const date = now.toISOString().split('T')[0];
  const apolloClient = initializeApollo();

  const { data } = await requestHandler(
    apolloClient.query<QuoteQuery>({
      query: QUERY_CURRENT_QUOTE,
      variables: {
        date: {
          eq: date,
        },
      },
      fetchPolicy: 'cache-first',
    }),
  );

  if (!data?.quotes?.data.length) {
    return null;
  }

  return data?.quotes?.data[0] as QuoteEntity;
};
